import { Spine } from "@esotericsoftware/spine-pixi-v8";
import {
    BitmapText,
    Container, Graphics, Sprite,
} from 'pixi.js';

import { sound } from "@pixi/sound";
import { gsap } from "gsap";
import {
    getSpineSymbol,
    getSymbol
} from "../config/getSymbol";
import { isSuperQuickBtnOnGlobal, RespinIndex } from "../config/GlobalVariableConfig";
import {
    HOLDSPIN_REEL_DIVIDER,
    HOLDSPIN_REEL_WIDTH,
    HOLDSPIN_ROW_DIVIDER,
    HOLDSPIN_SYMBOL_HEIGHT,
    HOLDSPIN_SYMBOL_WIDTH,
    REEL_BG_POS_ALL,
    REEL_DIVIDER,
    REEL_FRAME,
    REEL_NUMBERS,
    REEL_SCALE,
    REEL_WIDTH,
    REEL_x_POS,
    REEL_y_POS,
    SYMBOL_HEIGHT,
    SYMBOLS_PER_REEL,
    VISIBLE_SYMBOLS_PER_REEL
} from "../config/reelConfig";
import { GSAPScreenShake } from '../core/GSAPScreenShake';
import { Manager } from "../core/Manager";
import { GameConstants } from '../gameClientEvents/GameConstants';
import { spinData } from "../server/getServerResposesFun";

export let SYMBOLS_PER_REEL_FEATURE: number = 8;

export const BLANK_SYM_ID = 40;

export interface CellObject {
    view: Container;
    symbolId: number; // the id from the backend
    symbol: Sprite;
    coinVal: number; //  the number value of the coin
    coinValText: BitmapText; // the text font of the coin
}

export interface SymbolObject {
    view: Container;          //  container of the both cells ( the one which is in the view & the one on top of mask)
    cells: CellObject[];     // array of the all cells
    isWin: boolean;
    IdxCellOffView: number;     // which of the `symbols` is currently shown
}

export interface ReelObject {
    container: Container;
    reelIndex: number;
    symbols: SymbolObject[];
}

export interface reelOverlayObject {
    view: Container;
    symbolId: number | null; // the id from the backend
    symbol: Spine | null;
    coinVal: number | null; // the number value of the coin
    coinValText: BitmapText | null; // the text font of the coin
    coinValFinalText: BitmapText | null;
    multVal: number | null; // the number value of the multiplier
    multValText: BitmapText | null; // the text font of the multiplier
}

export class ReelInit extends Container {

    public allReelArray: ReelObject[];

    public reelOverlayContainer: Container;
    public reelOverlaySymbols: reelOverlayObject[][] = [];

    public anticipation: Spine[];

    private allReelContainer: Container;

    public spinLeftMeter: Spine;

    public winCollectionMeter: Spine;

    public totalWinVal: number = 0;
    public totalWinText: BitmapText;

    public collectTrail: Spine;

    private anticipationLoopSoundId: any = null;

    private maskTimeline: gsap.core.Timeline | null = null;

    constructor() {
        super();
        this.allReelContainer = new Container();
        this.allReelContainer.label = "allReelContainer";

        this.allReelArray = [];

        this.reelOverlayContainer = new Container();
        this.reelOverlayContainer.label = "reelOverlayContainer";

        this.anticipation = [];
        this.initReels();
    }

    public prevReelSymbols: number[][];
    public prevReelCoinValues: number[][];

    private initReels() {
        let prevXPos = 0;
        SYMBOLS_PER_REEL_FEATURE = 8//VISIBLE_SYMBOLS_PER_REEL[1];;
        const reelBackLeft = Sprite.from('reelBackleft');
        const reelBackMid = Sprite.from('reelBackMid');




        // reelGrid.anchor.set(0.5);

        const reelBackRight = Sprite.from('reelBackRight');
        const middleReelVisibleCount = VISIBLE_SYMBOLS_PER_REEL[1].toString();
        const configObj = REEL_BG_POS_ALL.find(obj => obj.hasOwnProperty(middleReelVisibleCount));
        const config = configObj ? configObj[middleReelVisibleCount as keyof typeof configObj] : null;
        // Initialize prevReelSymbols
        this.prevReelSymbols = Array.from({ length: REEL_NUMBERS }, () =>
            Array(SYMBOLS_PER_REEL_FEATURE).fill(BLANK_SYM_ID)
        );

        this.prevReelCoinValues = Array.from({ length: REEL_NUMBERS }, () =>
            Array(SYMBOLS_PER_REEL_FEATURE).fill(0)
        );

        // Copy values from triggerReelSymbols
        const triggerReelSymbols = spinData.respins[RespinIndex.value - 1].reelSymbols;
        const triggerCoinValues = spinData.respins[RespinIndex.value - 1].featureData?.coinInfo?.coinValues;
        triggerReelSymbols[0] = [31, 31, 31, 31, 31, 0, 0, 0];
        triggerReelSymbols[4] = [31, 31, 31, 31, 31, 30, 30, 30];

        for (let row = 0; row < triggerReelSymbols.length; row++) {
            for (let col = 0; col < triggerReelSymbols[row].length; col++) {

                const symbol = triggerReelSymbols[row][col];
                if (symbol >= GameConstants.GOLD_COIN_START_SYMBOL_ID && symbol <= GameConstants.GRAND_SYMBOL_ID || symbol === GameConstants.SILVER_WILD_SYMOL_ID || symbol === GameConstants.GOLDEN_WILD_SYMOL_ID || symbol === GameConstants.BLOCKED_SYMBOL_ID) {
                    this.prevReelSymbols[row][col] = symbol;
                }
                this.prevReelCoinValues[row][col] = triggerCoinValues[row][col];
            }
        }

        for (let i = 0; i < REEL_NUMBERS; i++) {
            let rn = (i > 0 && i < 4) ? 1 : (i === 4 ? 2 : i);
            let lastY = 0;
            const reelContainer = new Container();
            const reelBgContainer = new Container();
            reelContainer.label = "reelCont";
            const reelObj: ReelObject = {
                container: reelContainer,
                reelIndex: i,
                symbols: [],
            };

            let currentXPos = (i === 0) ? REEL_x_POS : prevXPos + REEL_WIDTH + REEL_DIVIDER[i];
            reelContainer.x = currentXPos;
            prevXPos = reelContainer.x;
            reelContainer.y = reelBgContainer.y = REEL_y_POS[i];
            reelContainer.label = `Reel_${i}`;
            if (i == 0) {
                reelBgContainer.position.set(config[rn].bgX, config[rn].bgY);
                reelBgContainer.addChild(reelBackRight);
            }
            if (i == 1) {
                reelBgContainer.position.set(config[rn].bgX, config[rn].bgY);
                reelBgContainer.label = "reelBackMid";
                reelBgContainer.addChild(reelBackMid);
            }
            if (i == 4) {
                reelBgContainer.position.set(config[rn].bgX, config[rn].bgY);
                reelBgContainer.addChild(reelBackLeft);
            }

            for (let j = 0; j < SYMBOLS_PER_REEL[i]; j++) {
                const symbolContainer = new Container();
                symbolContainer.label = "symbolContainer";
                const IdxCellOffView = 1;
                const cells: CellObject[] = [];

                for (let k = 0; k < 2; k++) {
                    const view = new Container();
                    view.label = "symbolView"

                    const symbolId = this.prevReelSymbols[i][j];

                    const symbol = Sprite.from(getSymbol(symbolId));
                    symbol.anchor.set(0.5);
                    view.addChild(symbol);

                    const coinVal = this.prevReelCoinValues[i][j];

                    const coinValText = new BitmapText({
                        text: "",
                        style: {
                            fontFamily: "coin_font",
                            fontSize: 100,
                            // letterSpacing: 3,
                        }
                    });
                    coinValText.anchor.set(0.5);
                    // view.addChild(coinValText);

                    if (k === IdxCellOffView) {
                        view.y -= HOLDSPIN_SYMBOL_HEIGHT;
                    }

                    const cellObj: CellObject = {
                        view,
                        symbolId,
                        symbol,
                        coinVal: coinVal,
                        coinValText,
                    };

                    symbolContainer.addChild(view);
                    cells.push(cellObj);
                }

                symbolContainer.x = REEL_FRAME + Math.round(HOLDSPIN_SYMBOL_WIDTH / 2);

                const doubleReelgap = 0;
                symbolContainer.y = (REEL_FRAME + Math.round(HOLDSPIN_SYMBOL_HEIGHT / 2) + j * (HOLDSPIN_SYMBOL_HEIGHT + HOLDSPIN_ROW_DIVIDER) + doubleReelgap);

                const cellMask = new Graphics()
                    .rect(-HOLDSPIN_SYMBOL_WIDTH / 2, -HOLDSPIN_SYMBOL_HEIGHT / 2, HOLDSPIN_SYMBOL_WIDTH, HOLDSPIN_SYMBOL_HEIGHT)
                    .fill(0xffffff);

                cellMask.label = "cellMask";

                cellMask.alpha = 0.5;
                symbolContainer.addChild(cellMask);
                symbolContainer.mask = cellMask;

                const symbolObj: SymbolObject = {
                    view: symbolContainer,
                    cells,
                    isWin: false,
                    IdxCellOffView,
                };

                reelObj.symbols.push(symbolObj);
                reelContainer.addChild(symbolContainer);
                if (symbolContainer.y > lastY) {
                    lastY = symbolContainer.y;
                }

            }

            if (i === 0 || i === 1 || i === 4) {
                this.allReelContainer.addChild(reelBgContainer);
            }
            this.allReelArray.push(reelObj);
            this.allReelContainer.addChild(reelContainer);

            if (i === 1 || i === 2 || i === 3) {
                const reelGrid = Sprite.from('grid');
                reelGrid.label = "reelGrid";
                reelGrid.x = REEL_FRAME - 395;
                reelGrid.y = REEL_FRAME;
                reelGrid.label = "reelGrid";
                reelContainer.addChild(reelGrid);
            }
            if (Array.isArray(SYMBOLS_PER_REEL)) {
                const visibleCount = VISIBLE_SYMBOLS_PER_REEL[i];
                const totalHeight = SYMBOL_HEIGHT * visibleCount;
                const bottomY = lastY + (SYMBOL_HEIGHT / 2);

                const topY = bottomY - totalHeight;

                const reelMask = new Graphics()
                    .rect(0, 0, REEL_WIDTH, totalHeight)
                    .fill(0x950a5a);

                reelMask.x = REEL_FRAME;
                reelMask.y = topY;
                reelMask.y = (SYMBOL_HEIGHT * SYMBOLS_PER_REEL[i]) - totalHeight;
                reelMask.label = `reelMask_${i}`;
                reelContainer.addChild(reelMask);
                reelMask.alpha = .5;
                reelContainer.mask = reelMask;
            }

        }


        const doubleReelExtragap = 0;
        if (!Array.isArray(SYMBOLS_PER_REEL)) {
            const reactMark = new Graphics()
                .rect(REEL_FRAME, REEL_FRAME,
                    HOLDSPIN_REEL_WIDTH * REEL_NUMBERS + (REEL_NUMBERS - 1) * HOLDSPIN_REEL_DIVIDER,
                    HOLDSPIN_SYMBOL_HEIGHT * SYMBOLS_PER_REEL_FEATURE + (SYMBOLS_PER_REEL_FEATURE - 1) * HOLDSPIN_ROW_DIVIDER + doubleReelExtragap)
                .fill(0x950a5a);

            reactMark.label = "reelMask";

            reactMark.alpha = 0.5;
            this.allReelContainer.addChild(reactMark);
            this.allReelContainer.mask = reactMark;
        }




        this.addChild(this.allReelContainer);

        this.position.set(1500, 1500);
        this.animateMask();
        this.reelOverlayContainer.destroy();
        this.initReelOverlayContainer();
        // this.allReelContainer.addChild(reelGrid);
        this.updateGridLayout();
        this.setupSpinLeftMeter();
        this.setupWinCollectionMeter();
        this.setupTotalWin();
        //this.setupTrailAnimations();

    }

    private updateGridLayout() {

        const reelGrid = this.reelOverlayContainer.getChildByName("reelGrid") as Sprite;
        if (!reelGrid) return;

        const middleReel = this.allReelArray[1].container;
        if (!middleReel) return;

        const visibleCount = VISIBLE_SYMBOLS_PER_REEL[1];
        const totalHeight = SYMBOL_HEIGHT * visibleCount;

        const totalWidth =
            REEL_NUMBERS * REEL_WIDTH +
            (REEL_NUMBERS - 1) * REEL_DIVIDER[1];

        // --- Center grid over reel area ---
        // for (let i = 0; i <= 3; i++) {
        //     const reelContainer = this.allReelArray[i]?.container;
        //     if (!reelContainer) continue;

        //     const reelGrid = reelContainer.getChildByName("reelGrid") as Sprite;
        //     if (!reelGrid) continue;

        reelGrid.position.set(
            REEL_FRAME + totalWidth * 0.5,
            REEL_FRAME + totalHeight * 0.5
        );

        //     const reelMask = reelContainer.getChildByName(`reelMask_${i}`) as Graphics;
        //     if (reelMask) {
        //         reelGrid.mask = reelMask;
        //     }
        // }

        // --- Scale grid to match visible height ---
        // const scaleY = totalHeight / reelGrid.texture.height;
        // const scaleX = totalWidth / reelGrid.texture.width;

        // reelGrid.scale.set(scaleX, scaleY);

        // --- Sync transform with reel container ---
        this.reelOverlayContainer.position.copyFrom(this.allReelContainer.position);
        this.reelOverlayContainer.scale.copyFrom(this.allReelContainer.scale);

        // --- Clip grid with middle reel mask ---
        const middleMask = middleReel.getChildByName(`reelMask_1`) as Graphics;
        if (middleMask) {
            reelGrid.mask = middleMask;
        }
    }

    private setupSpinLeftMeter() {

        this.spinLeftMeter = Spine.from({
            skeleton: "spinLeftSkel",
            atlas: "spinLeftAtlas",
        });
        this.spinLeftMeter.label = "spinLeftMeter";
        this.spinLeftMeter.scale = 1;

        this.addChild(this.spinLeftMeter);
        this.updateSpinLeftMeterPosition();

        this.spinLeftMeter.visible = false;

    }

    private updateSpinLeftMeterPosition() {
        if (!this.spinLeftMeter || !this.allReelContainer) {
            return;
        }

        const reelBounds = this.allReelContainer.getLocalBounds();
        if (reelBounds.width <= 0 || reelBounds.height <= 0) {
            const fallbackX = 540;
            const fallbackY = 960;
            this.spinLeftMeter.position.set(fallbackX, fallbackY);
            this.winCollectionMeter?.position.set(fallbackX, fallbackY);
            return;
        }

        const meterX = reelBounds.x + (reelBounds.width * 0.5);
        const meterY = reelBounds.y + reelBounds.height + (HOLDSPIN_SYMBOL_HEIGHT * 0.1);
        this.spinLeftMeter.position.set(meterX, meterY);
        this.winCollectionMeter?.position.set(meterX, meterY);

    }

    //@ts-ignore
    private setupWinCollectionMeter() {

        this.winCollectionMeter = Spine.from({
            skeleton: "winCollectMeterSkel",
            atlas: "winCollectMeterAtlas",
        });
        this.winCollectionMeter.label = "winCollectionMeter";

        this.winCollectionMeter.scale = 0.6;

        this.addChild(this.winCollectionMeter);
        this.updateSpinLeftMeterPosition();

        this.winCollectionMeter.visible = false;

        this.winCollectionMeter.state.addListener({
            complete: (entry: any) => {
                if (["digital_pannel_appear", "digital_pannel_collect"].includes(entry.animation.name)) {
                    this.winCollectionMeter.state.setAnimation(0, "digital_pannel_loop", true);
                }
            }
        });

    }


    private setupTotalWin() {

        this.totalWinVal = 0;
        this.totalWinText = new BitmapText({
            text: '',
            style: {
                fontFamily: "coin_font",
                trim: true,
                fontSize: 80,
                // letterSpacing: 10,
            }
        });
        this.totalWinText.anchor = 0.5;
        if (this.winCollectionMeter) {
            this.winCollectionMeter.addSlotObject("amount", this.totalWinText);
        }
    }


    private topReelGridAnticipation: Spine | null = null;
    private bottomReelGridAnticipation: Spine | null = null;


    private isTopReelAnticipationActive = false;

    public topReelGridAnticipationOn() {

        if (!this.isTopReelAnticipationActive) {
            //  sound.play('maxwin_anticipation_start', { volume: 1 });
            this.topReelGridAnticipation.state.setAnimation(0, "in", false).listener = {
                complete: () => {
                    this.isTopReelAnticipationActive = true;
                    this.anticipationLoopSoundId = sound.play('maxwin_anticipation_loop', { volume: 1, loop: true });
                    this.topReelGridAnticipation.state.setAnimation(0, "loop", true);
                    this.topReelGridAnticipation.state.clearListeners();
                }
            }
        }
    }

    public animateMask(skipAnimation: boolean = true) {
        if (this.maskTimeline) {
            this.maskTimeline.kill();
            this.maskTimeline = null;
        }

        const speedMultiplier = isSuperQuickBtnOnGlobal ? 5.5 : 1;
        const middleReelVisibleCount = VISIBLE_SYMBOLS_PER_REEL[1].toString();
        const configObj = REEL_BG_POS_ALL.find(obj => obj.hasOwnProperty(middleReelVisibleCount));
        const config = configObj ? configObj[middleReelVisibleCount as keyof typeof configObj] : null;


        if (!skipAnimation) {
            this.maskTimeline = gsap.timeline({
                defaults: { duration: 0.5, ease: "power2.out", overwrite: true }
            });
            this.maskTimeline.timeScale(speedMultiplier);
        }


        if (config) {
            const midBgData = config[1];
            let middleBgContainer = this.allReelContainer.getChildByName("reelBackMid", true) as Container;
            const parentCont = this.allReelContainer.parent as Container;

            const bgProps = {
                pixi: {
                    x: midBgData.bgX, y: midBgData.bgY,
                    scaleX: midBgData.bgScaleX, scaleY: midBgData.bgScaleY
                }
            };

            let orientationScale = (Manager.Orientation === "LANDSCAPE") ? REEL_SCALE[(VISIBLE_SYMBOLS_PER_REEL[1] - 4)] : 1;

            const parentProps = {
                pixi: { scale: orientationScale }
            };

            if (skipAnimation) {
                if (middleBgContainer) gsap.set(middleBgContainer, bgProps);
                if (parentCont) gsap.set(parentCont, parentProps);
            } else {
                if (middleBgContainer) this.maskTimeline!.to(middleBgContainer, bgProps, 0);
                if (parentCont) {
                    this.maskTimeline!.to(parentCont, parentProps, 0);
                    GSAPScreenShake.stop();
                    GSAPScreenShake.shake([this], 1500 / speedMultiplier);
                }
            }
        }

        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            const container = this.allReelArray[reelNum].container;
            let reelMask = container.getChildByName(`reelMask_${reelNum}`) as Graphics;

            if (!reelMask) {
                reelMask = new Graphics().rect(0, 0, REEL_WIDTH, 1).fill(0x950a5a);
                reelMask.label = `reelMask_${reelNum}`;
                reelMask.x = REEL_FRAME;
                container.addChild(reelMask);
                container.mask = reelMask;
            }

            const visibleCount = VISIBLE_SYMBOLS_PER_REEL[reelNum];
            const targetHeight = SYMBOL_HEIGHT * visibleCount;
            const targetY = (SYMBOL_HEIGHT * SYMBOLS_PER_REEL[reelNum]) - targetHeight;

            const maskProps = { pixi: { height: targetHeight, y: targetY } };

            if (skipAnimation) {
                gsap.set(reelMask, maskProps);
                if (config) {
                    let rn = (reelNum > 0 && reelNum < 4) ? 1 : (reelNum === 4 ? 2 : reelNum);
                    gsap.set(container, { pixi: { y: config[rn].reelY } });
                }
            } else {
                this.maskTimeline!.to(reelMask, maskProps, 0);
                if (config) {
                    let rn = (reelNum > 0 && reelNum < 4) ? 1 : (reelNum === 4 ? 2 : reelNum);
                    this.maskTimeline!.to(container, { pixi: { y: config[rn].reelY } }, 0);
                }
            }
        }

        this.updateGridLayout();
        this.updateSpinLeftMeterPosition();
    }

    private isBottomReelAnticipationActive = false;
    public bottomReelGridAnticipationOn() {

        if (!this.isBottomReelAnticipationActive) {
            // sound.play('maxwin_anticipation_start', { volume: 1 });
            this.bottomReelGridAnticipation.state.setAnimation(0, "in", false).listener = {
                complete: () => {
                    this.isBottomReelAnticipationActive = true;
                    this.anticipationLoopSoundId = sound.play('maxwin_anticipation_loop', { volume: 1, loop: true });
                    this.bottomReelGridAnticipation.state.setAnimation(0, "loop", true);
                    this.bottomReelGridAnticipation.state.clearListeners();
                }
            }
        }
    }

    public endTopReelGridAnticipation() {
        if (this.isTopReelAnticipationActive) {
            this.topReelGridAnticipation.state.setAnimation(0, "out", false);
            if (this.anticipationLoopSoundId !== null) {
                sound.stop('maxwin_anticipation_loop');
                this.anticipationLoopSoundId = null;
            }

        }

    }

    public endBottomReelGridAnticipation() {
        if (this.isBottomReelAnticipationActive) {
            this.bottomReelGridAnticipation.state.setAnimation(0, "out", false);
            if (this.anticipationLoopSoundId !== null) {
                sound.stop('maxwin_anticipation_loop');
                this.anticipationLoopSoundId = null;
            }

        }
    }



    public initReelOverlayContainer() {
        this.reelOverlayContainer = new Container();
        this.reelOverlayContainer.x = this.allReelContainer.x;
        this.reelOverlayContainer.y = this.allReelContainer.y;

        this.addChild(this.reelOverlayContainer);



        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {

            if (!this.reelOverlaySymbols[reelNum]) {
                this.reelOverlaySymbols[reelNum] = [];
            }

            for (let posNum = 0; posNum < SYMBOLS_PER_REEL_FEATURE; posNum++) {

                const view = new Container();


                const reelOverlayObject: reelOverlayObject = {
                    view: view,
                    symbolId: null,
                    symbol: null,
                    coinVal: null,
                    coinValText: null,
                    coinValFinalText: null,
                    multVal: null,
                    multValText: null,
                };
                // view.y = (REEL_FRAME + Math.round(HOLDSPIN_SYMBOL_HEIGHT / 2) + posNum * (HOLDSPIN_SYMBOL_HEIGHT + HOLDSPIN_ROW_DIVIDER));
                // view.x = REEL_FRAME + Math.round(HOLDSPIN_SYMBOL_WIDTH / 2) + reelNum * (HOLDSPIN_REEL_WIDTH + HOLDSPIN_REEL_DIVIDER);

                const symbolContainer = this.allReelArray[reelNum].symbols[posNum].view;
                const globalPos = symbolContainer.getGlobalPosition();
                const localPos = this.allReelContainer.toLocal(globalPos);

                view.x = localPos.x;
                view.y = localPos.y;

                view.label = `${reelNum * SYMBOLS_PER_REEL_FEATURE + posNum}`;
                this.reelOverlayContainer.addChild(view);

                this.reelOverlaySymbols[reelNum][posNum] = reelOverlayObject;
            }
        }


        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            for (let posNum = 0; posNum < SYMBOLS_PER_REEL_FEATURE; posNum++) {

                if (this.prevReelSymbols[reelNum][posNum] != BLANK_SYM_ID) {
                    this.addReelSymbolsToContainer(reelNum, posNum, true);
                }
            }
        }


    }



    //@ts-ignore
    // private setupTrailAnimations() {

    //     this.collectTrail = Spine.from({
    //         skeleton: "collectTrailSkel",
    //         atlas: "collectTrailAtlas"
    //     });

    //     console.log("setupTrailAnimations", "collectTrail")

    //     this.collectTrail.label = "collectTrail";
    //     this.collectTrail.position.set(
    //         520,
    //         120
    //     );


    //     // this.collectTrail.state.setAnimation(0, `bonus_reel_trail_1`, true);
    //     // this.collectTrail.state.setAnimation(1, `bonus_reel_trail_2`, true);
    //     // this.collectTrail.state.setAnimation(2, `bonus_reel_trail_3`, true);
    //     // this.collectTrail.state.setAnimation(3, `bonus_reel_trail_4`, true);
    //     // this.collectTrail.state.setAnimation(4, `bonus_reel_trail_5`, true);

    //     this.addChild(this.collectTrail);
    // }




    public animateCoinValueUpdate(text: BitmapText, fromValue: number, toValue: number): Promise<void> {
        return new Promise<void>((resolve) => {
            fromValue;
            // Scale by bet and format as integer with 'X'
            const amount = toValue;
            text.text = `${amount}x`;//amount.toLocaleString() + "X";
            resolve();

        });
    }

    public addReelSymbolsToContainer(reelNum: number, posNum: number, isCalledFromInit: boolean = false) {

        let prevSymbolSpine = this.reelOverlaySymbols[reelNum][posNum].symbol;
        if (prevSymbolSpine != null) {
            return;
        }

        // const visibleCount = VISIBLE_SYMBOLS_PER_REEL[1].toString();
        // const configObj = REEL_BG_POS_ALL.find(obj => obj.hasOwnProperty(visibleCount));
        // const config = configObj ? configObj[visibleCount as keyof typeof configObj] : null;

        // if (config) {
        //     let rn = (reelNum > 0 && reelNum < 4) ? 1 : (reelNum === 4 ? 2 : 0);
        //     for (let posNum = 0; posNum < SYMBOLS_PER_REEL[reelNum]; posNum++) {
        //         const symbolCont = this.allReelArray[reelNum].symbols[posNum].view;
        //         symbolCont.y = config[rn].reelY + Math.round(SYMBOL_HEIGHT / 2) + posNum * SYMBOL_HEIGHT;
        //     }
        // }


        // make the alpha 0 of the sprite on back
        const symbolObj = this.allReelArray[reelNum].symbols[posNum];
        symbolObj.view.alpha = 0;

        const IdxCellInView = 1 - this.allReelArray[reelNum].symbols[posNum].IdxCellOffView;

        const symbolIdFromBase = this.allReelArray[reelNum].symbols[posNum].cells[IdxCellInView].symbolId;
        const symbolId = (symbolIdFromBase >= GameConstants.GOLD_COIN_START_SYMBOL_ID && symbolIdFromBase <= GameConstants.GRAND_SYMBOL_ID || symbolIdFromBase === GameConstants.SILVER_WILD_SYMOL_ID || symbolIdFromBase === GameConstants.GOLDEN_WILD_SYMOL_ID || symbolIdFromBase === GameConstants.BLOCKED_SYMBOL_ID) ? symbolIdFromBase : BLANK_SYM_ID;

        const coinVal = this.allReelArray[reelNum].symbols[posNum].cells[IdxCellInView].coinVal;

        const symbol = getSpineSymbol(symbolId);

        const coinValText = new BitmapText({
            text: `${coinVal}x`,
            style: {
                fontFamily: "coin_font",
                fontSize: 100,
                // letterSpacing: 10,
            }
        });

        const reelOverlaySymbolView = this.reelOverlaySymbols[reelNum][posNum].view;
        this.reelOverlaySymbols[reelNum][posNum].symbolId = symbolId;
        this.reelOverlaySymbols[reelNum][posNum].symbol = symbol;
        this.reelOverlaySymbols[reelNum][posNum].coinVal = coinVal;
        this.reelOverlaySymbols[reelNum][posNum].coinValText = coinValText;
        if (reelNum !== undefined && posNum !== undefined) {
            this.reelOverlaySymbols[reelNum][posNum].coinValFinalText = coinValText;
        }

        if (symbolId === GameConstants.SILVER_WILD_SYMOL_ID || symbolId === GameConstants.GOLDEN_WILD_SYMOL_ID) {
            if (posNum < 7) {
                return;
            }
            else {
                symbol.state.setAnimation(0, "idle_up", false);
            }
        }

        reelOverlaySymbolView.addChild(symbol);
        if (symbolId == GameConstants.BLOCKED_SYMBOL_ID) {
            this.reelOverlaySymbols[reelNum][posNum].view.visible = false;
        } else {
            const visPos = SYMBOLS_PER_REEL[reelNum] - VISIBLE_SYMBOLS_PER_REEL[reelNum];
            if (posNum >= visPos) {
                this.reelOverlaySymbols[reelNum][posNum].view.visible = true;
            } else {
                this.reelOverlaySymbols[reelNum][posNum].view.visible = false;
            }

        }

        const coinValTextScale = Math.min(150 / symbol.width, 1);
        coinValText.scale = coinValTextScale;
        //reelOverlaySymbolView.addChild(coinValText);
        coinValText.anchor.set(0.5);

        // if (symbolId >= 16 && symbolId <= 18) {// do not show the multiplier values on jackpot coins
        //     coinValText.alpha = 0;
        // }

        if (!isCalledFromInit) {
            // sound.play('coin_appear_sound', { volume: 1 });
        }
        if ((symbolId >= GameConstants.GOLD_COIN_START_SYMBOL_ID &&
            symbolId <= GameConstants.GOLD_COIN_END_SYMBOL_ID) ||
            symbolId === GameConstants.MINI_SYMBOL_ID ||
            symbolId === GameConstants.MINOR_SYMBOL_ID ||
            symbolId === GameConstants.MAJOR_SYMBOL_ID ||
            symbolId === GameConstants.GRAND_SYMBOL_ID
        ) {
            const timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
            sound.play('coin_multiplier', { volume: 1, speed: timeScale });
            symbol.state.setAnimation(0, "appear", false).listener = {
                complete: () => {
                    symbol.state.setAnimation(0, "idle", true);
                    symbol.state.clearListeners();
                }
            }
        }




    }


    public addMultToCoinInContainer(reelNum: number, posNum: number, multValue: number): Promise<void> {

        return new Promise<void>((resolve) => {

            const reelSymbol = this.reelOverlaySymbols[reelNum][posNum];
            if (reelSymbol.symbol == null) {
                resolve();
            }

            const reelSymbolSpine = reelSymbol.symbol;

            const reelSymbolView = reelSymbol.view;

            const multiplierTrail = Spine.from({
                skeleton: "bonusCoinTrailSkel",
                atlas: "bonusCoinTrailAtlas",
            });
            multiplierTrail.label = "multiplierTrail";
            reelSymbolView.addChild(multiplierTrail);


            multiplierTrail.state.setAnimation(0, "bonus_coin_trail", false).listener = {
                complete: () => {

                    sound.play("multiplier_hit", { volume: 1 });
                    reelSymbolSpine.state.setAnimation(0, "multiplier_land_effect", false).listener = {
                        complete: () => {
                            reelSymbolSpine.state.setAnimation(0, "multipler_idle", true);
                            reelSymbolSpine.state.clearListeners();
                        }
                    }

                    reelSymbol.multVal = multValue;

                    const multValTextBitmap: BitmapText = new BitmapText({
                        text: "",
                        style: {
                            fontFamily: "witch_coin_multiplier",
                            fontSize: 50,
                            letterSpacing: 5,
                        }
                    });

                    // if text is already added then use it otherwise create a new Text
                    const multValText = reelSymbol.multValText ? reelSymbol.multValText : multValTextBitmap;
                    multValText.text = `X${multValue}`;
                    multValText.anchor.set(0.5);
                    //multValText.position.set(30, -55);
                    //reelSymbolView.addChild(multValText);
                    //reelSymbolSpine.addSlotObject("multiplier", multValText);


                    reelSymbol.multValText = multValText;


                    resolve();
                    multiplierTrail.state.clearListeners();

                    reelSymbolView.removeChild(multiplierTrail);
                    multiplierTrail.destroy();

                }
            }



        })

    }

}
